import script from "./UploadSdk.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSdk.vue?vue&type=script&setup=true&lang=js"

import "./UploadSdk.vue?vue&type=style&index=0&id=3e11bd8a&lang=scss"

const __exports__ = script;

export default __exports__